<div class="modal-container">
  <div class="modal-content">
    <div class="main-section">
      <div class="title">{{ "CHECKOUT_PAGE.CREDIT_CARD" | translate }}</div>

      <iframe #cardFrame src="https://app-payment-page.bilbayt.com/"></iframe>

      <div class="save-card" tappable (click)="saveCard = !saveCard">
        <ion-icon *ngIf="!saveCard" src="/assets/custom-icons/b-square.svg"></ion-icon>
        <ion-icon class="checked-icon" *ngIf="saveCard" src="/assets/custom-icons/b-check-square.svg"></ion-icon>
        <div>{{ "CHECKOUT_PAGE.SAVE_CARD" | translate }}</div>
      </div>

      <div class="card-error" [class.invisible]="!cardError">{{ cardError }}</div>
    </div>

    <div class="footer-section">
      <ion-button class="custom-button" expand="block" color="grey" (click)="onDismiss()">{{ "CANCEL" | translate }}</ion-button>
      <ion-button class="custom-button" expand="block" color="green" (mousedown)="$event.preventDefault(); onSubmit()">
        <ng-container *ngIf="!isLoading">{{ "DONE" | translate }} </ng-container>
        <ion-icon *ngIf="isLoading" class="spinning-icon" src="/assets/custom-icons/b-spinner.svg"></ion-icon>
      </ion-button>
    </div>
  </div>
</div>
